module.exports = __webpack_public_path__ + "static/media/Primary_Master.3e1ecc8f.svg";